import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
    template: `
    <div class="mat-card">
        <h3>We are all set to update your project script. </h3>
        <div>
            <p>Please note this action cannot be undone.</p>
        </div>
        <div class="actions">
            <button mat-button color="warn" [mat-dialog-close] >Cancel</button>
            <button mat-raised-button color="primary" [mat-dialog-close]="'ok'" cdkFocusInitial>Confirm</button>
        </div>
    </div>
  `,
    styles: [
        `
        .mat-card{
            padding: 8px;
            height: 100%;
            display: flex; 
            flex-direction: column;
            justify-content: space-between;
        }
        
        .actions{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            width: 100%;
        }
        
        
        h3{
            margin-bottom: 0;
            padding: 4px 0px 0px 4px;
        }
        
        p{
            padding: 12px 12px 12px 12px;
            margin:0;
        }
    `
    ]
})
export class UploadTranslationFileConfirmationDialog {
    constructor(
        public dialogRef: MatDialogRef<UploadTranslationFileConfirmationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: {},
    ) { }

}

@Component({
    template: `
    <div class="mat-card">
        <h3>Sorry, we do not recognize this file format. </h3>
        <div>
            <p>Please make sure that the original .csv file was generated from this experiences and has not been corrupted in any way.</p>
        </div>
        <div class="actions">
            <button mat-button color="warn" [mat-dialog-close] >OK</button>
        </div>
    </div>
  `,
    styles: [
        `
        .mat-card{
            padding: 8px;
            height: 100%;
            display: flex; 
            flex-direction: column;
            justify-content: space-between;
        }
        
        .actions{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            width: 100%;
        }
        
        
        h3{
            margin-bottom: 0;
            padding: 4px 0px 0px 4px;
        }
        
        p{
            padding: 12px 12px 12px 12px;
            margin:0;
        }
    `
    ]
})
export class TranslationErrorDialog {
    constructor(
        public dialogRef: MatDialogRef<TranslationErrorDialog>,
        @Inject(MAT_DIALOG_DATA) public data: {},
    ) { }

}